<script setup lang="ts">
import { useModalStore } from "../../store/modal";
import ActionModalBase from "./ActionModalBase.vue";

const modalStore = useModalStore()
</script>

<template>
<action-modal-base :reverse="true">
   <button @click.prevent="modalStore.open('MessageAttachmentInput', {type: 'document'}, '.message-send-box', 'none' )">Attach document</button>
    <button @click.prevent="modalStore.open('MessageAttachmentInput', {type: 'media'}, '.message-send-box', 'none')">Attach media</button>
</action-modal-base>
</template>

<style scoped lang="scss">

</style>
